import { connect } from 'react-redux';

import CartUpsellV2 from 'components/CartUpsellV2';
import * as actions from 'state/actions';
import { ADD_TO_CART_ANALYTICS_ORIGINS } from 'state/constants';
import CartSelector from 'state/selectors/cart';

const mapStateToProps = (state, ownProps) => {
  const cartUpsells = CartSelector.getCartUpsells(state) || {};
  const isLoading = CartSelector.getIsBeingFetched(state);
  const recommendationPairingNames = CartSelector.getRecommendationPairingNames(state);

  return {
    cartUpsells,
    isLoading,
    recommendationPairingNames,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  trackEvent: ({ eventAction, eventLabel, eventValue, dyDecisionId, dyVariationId }) => {
    dispatch(actions.trackUpsellEvent({ eventAction, eventLabel, eventValue }));
    if (dyDecisionId && dyVariationId) {
      dispatch(
        actions.trackEngagementClick({
          eventAction,
          eventLabel,
          dyDecisionId,
          dyVariationId,
        })
      );
    }
  },
  addToCart: id =>
    dispatch(
      actions.addLineItems({ [id]: 1 }, { origination: ADD_TO_CART_ANALYTICS_ORIGINS.UPSELL })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartUpsellV2);
